// Samen wonen (golf 8, 0049_samen_wonen; docs/onderzoek/golf8-samenwonen-en-ouderen.md §2.5): Wie
// eet mee, Reserveren, Kosten delen en "Richt het huis in". Handgeschreven zoals memorize.ts en
// gelijk aan de API (apps/api/src/routes/v1/app/dinner.ts, bookings.ts, expenses.ts en
// houseSetup.ts); openapi.contract.test.ts bewaakt elke aanroep. Alleen de ouderapp; de kiosk krijgt
// zijn blokken via de sync (KioskDinnerView en KioskBookingsView hieronder).
const id = (v) => encodeURIComponent(v);
function query(params) {
    const parts = Object.entries(params)
        .filter((e) => e[1] !== undefined)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
    return parts.length > 0 ? `?${parts.join('&')}` : '';
}
export function createSamenClient(t, baseUrl = '') {
    const get = (path) => t.request('GET', path);
    const post = (path, body = {}) => t.request('POST', path, body);
    const put = (path, body) => t.request('PUT', path, body);
    const patch = (path, body) => t.request('PATCH', path, body);
    return {
        dinner: {
            overview: (from, days) => get(`/v1/app/dinner${query({ from, days: days === undefined ? undefined : String(days) })}`),
            start: () => post('/v1/app/dinner/start'),
            settings: (input) => put('/v1/app/dinner/settings', input),
            day: (date, input) => put(`/v1/app/dinner/${id(date)}`, input),
            signup: (date, memberId, status, guests = 0) => put(`/v1/app/dinner/${id(date)}/signups/${id(memberId)}`, {
                status,
                guests,
            }),
            preference: (memberId, defaultIn, defaultOut) => put(`/v1/app/dinner/preferences/${id(memberId)}`, {
                default_in: defaultIn,
                default_out: defaultOut,
            }),
        },
        bookings: {
            overview: (from, to, resourceId) => get(`/v1/app/bookings${query({ from, to, resource_id: resourceId })}`),
            resources: (archived = false) => get(`/v1/app/bookings/resources${query({ archived: archived ? '1' : undefined })}`),
            createResource: (input) => post('/v1/app/bookings/resources', input),
            updateResource: (resourceId, input) => patch(`/v1/app/bookings/resources/${id(resourceId)}`, input),
            archiveResource: (resourceId) => post(`/v1/app/bookings/resources/${id(resourceId)}/archive`),
            unarchiveResource: (resourceId) => post(`/v1/app/bookings/resources/${id(resourceId)}/unarchive`),
            create: (input) => post('/v1/app/bookings', input),
            /** Inkorten ("Klaar, maak vrij") of verlengen. */
            end: (bookingId, endsAt, ifVersion) => patch(`/v1/app/bookings/${id(bookingId)}`, {
                ends_at: endsAt,
                if_version: ifVersion,
            }),
            cancel: (bookingId) => post(`/v1/app/bookings/${id(bookingId)}/cancel`),
        },
        expenses: {
            list: (opts = {}) => get(`/v1/app/expenses${query({
                cursor: opts.cursor,
                limit: opts.limit === undefined ? undefined : String(opts.limit),
                deleted: opts.deleted ? '1' : undefined,
            })}`),
            get: (expenseId) => get(`/v1/app/expenses/${id(expenseId)}`),
            balances: () => get('/v1/app/expenses/balances'),
            /** De CSV (UTF-8 met BOM, scheidingsteken per taal): als link openen. */
            csvUrl: () => `${baseUrl}/v1/app/expenses/export.csv`,
            create: (input) => post('/v1/app/expenses', input),
            update: (expenseId, input) => patch(`/v1/app/expenses/${id(expenseId)}`, input),
            remove: (expenseId) => post(`/v1/app/expenses/${id(expenseId)}/delete`),
            restore: (expenseId) => post(`/v1/app/expenses/${id(expenseId)}/restore`),
            ask: (expenseId) => post(`/v1/app/expenses/${id(expenseId)}/question`),
            withdraw: (expenseId) => post(`/v1/app/expenses/${id(expenseId)}/question/withdraw`),
            resolve: (expenseId) => post(`/v1/app/expenses/${id(expenseId)}/question/resolve`),
            settle: (input) => post('/v1/app/expenses/settlements', input),
            confirmSettlement: (settlementId) => post(`/v1/app/expenses/settlements/${id(settlementId)}/confirm`),
            deleteSettlement: (settlementId) => post(`/v1/app/expenses/settlements/${id(settlementId)}/delete`),
            close: (throughDate) => post('/v1/app/expenses/checkpoints', { through_date: throughDate }),
        },
        house: {
            /** "Richt het huis in": voegt alleen toe, maakt nooit iets dubbel. */
            setup: (profile) => post('/v1/app/house/setup', profile ? { house_profile: profile } : {}),
        },
    };
}
//# sourceMappingURL=samen.js.map